import React, { useState } from "react"
import ConfirmModal from "../ConfirmModal/ConfirmModal"

interface TextInputModalProps {
  onConfirm: (value: string) => void
  title?: string
  initialValue?: string
  placeholder?: string
  [key: string]: any
}

const TextInputModal: React.FunctionComponent<TextInputModalProps> = ({
  onConfirm,
  title = "Edit",
  initialValue = "",
  placeholder = "Enter text",
  ...props
}) => {
  const [text, setText] = useState(initialValue)
  return (
    <ConfirmModal
      title={title}
      onConfirm={() => {
        onConfirm(text)
      }}
      {...props}
    >
      <div className="flex justify-center items-center w-full input-container pt-4 pb-8">
        <input
          className="form-control form-control--first form-control--last"
          name="text"
          type="text"
          value={text}
          placeholder={placeholder}
          onChange={(e) => setText(e.target.value)}
        />
      </div>
    </ConfirmModal>
  )
}

export default TextInputModal
